import { TenantConfig } from '@/types/TenantConfig'

export const glenstone: TenantConfig = {
  logo: 'assets/glenstone/static/logo.svg',
  themeOptions: {
    headerBackground: 'white',
    headerHeight: '32px',
    // Same as .cart .total-prices background color.
    cartHeaderBackgroundColor: '#f5f5f5',
    cartHeaderTextColor: 'black',
    primaryColor: '#595e64',
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/glenstone/static/success.jpg',
      },
      completedContentOffset: {
        desktop: '-140px',
        mobile: '-7px',
      },
    },
    checkoutRoute: {
      hideBackButton: true,
    },
  },
  i18nOverrides: {
    en: {
      reserve: {
        title: '',
      },
      checkoutRoute: {
        title: '',
      },
    },
  },
}
